import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import { useCallback } from 'react'
import { NavLink } from 'react-router-dom'

import {
  selectAuthConfirmAction, selectIsLoading, selectRecallPassword, selectRecoveryPassword,
} from '@src/store/ducks/auth/selectors'
import style from '@src/pages/RecoveryPassword/RecoveryPassword.module.scss'
import { Title } from '@src/components/Title/Title'
import { RecoveryPasswordFirstForm } from '@src/pages/RecoveryPassword/RecoveryPasswordFirstForm'
import { confirmActionsRecoveryPassword } from '@src/store/ducks/auth/thunks'
import { SmsModal } from '@src/components/SmsModal/SmsModal'
import { AppDispatch } from '@src/store/store'
import { RecoveryPasswordSecondForm } from '@src/pages/RecoveryPassword/RecoveryPasswordSecondForm'
import { Modal } from '@src/components/Modal/Modal'
import { Button } from '@src/components/Button/Button'
import { setIsSuccessChangePhone } from '@src/store/ducks/user/reducer'
import { setConfirmAction } from '@src/store/ducks/auth/reducer'

export const RecoveryPassword = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isConfirmAction = useSelector(selectAuthConfirmAction)
  const recallPasswordSuccess = useSelector(selectRecallPassword)
  const recoveryPasswordSuccess = useSelector(selectRecoveryPassword)
  const isLoading = useSelector(selectIsLoading)

  const closeModal = useCallback(() => {
    dispatch(setIsSuccessChangePhone(false))
    dispatch(setConfirmAction(false))
  }, [dispatch])

  return (
    <div className={cn(style.recoveryPassword)}>
      <div className={style.recoveryPassword__body}>
        <div className={style.title}>
          <Title greenTitle="Восстановление" title="пароля" />
        </div>
        <div>
          {recallPasswordSuccess ? (
            <RecoveryPasswordSecondForm />
          ) : (
            <RecoveryPasswordFirstForm />
          )}

        </div>
        <SmsModal
          closeModal={closeModal}
          isConfirmAction={isConfirmAction}
          callback={(code) => dispatch(confirmActionsRecoveryPassword(code))}
        />
        <Modal isOpen={recoveryPasswordSuccess}>
          <>
            <div className={style.titleModal}>Пароль успешно восстановлен</div>
            <NavLink to="/lk/login">
              <Button loading={isLoading} type="secondary">Перейти на страницу авторизации</Button>
            </NavLink>
          </>
        </Modal>
      </div>
    </div>
  )
}
